import { useCallback } from 'react';

import { TServerSendResponse } from '../types';
import { useGenericSend } from './useGenericSend';

export const useCancelWithdraw = () => {
    const send = useGenericSend();

    return useCallback(async (
        { transactionCode, reason }: { transactionCode: string; reason?: string }
    ): Promise<TServerSendResponse> => {
        const { data } = await send<{ transactionCode: string; reason?: string }, TServerSendResponse>({
            ID: 33020,
            responses: [33021, 33022],
            description: 'Cancel withdraw',
            transactionCode,
            ...reason && { reason }
        });

        return data;
    }, [send]);
};
